import { __assign, __extends } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import classnames from 'classnames';
import Input from '../../../Input';
import styles from './set-link-modal.scss';
var SetLinkModal = /** @class */ (function (_super) {
    __extends(SetLinkModal, _super);
    function SetLinkModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (url) {
            var validateUrl = _this.props.componentData.validateUrl;
            var isValid = validateUrl(url);
            _this.setState({ url: url, isValid: isValid });
        };
        _this.onConfirm = function () {
            var url = _this.state.url;
            var _a = _this.props, componentData = _a.componentData, _b = _a.componentData, validateUrl = _b.validateUrl, updateUrl = _b.updateUrl, helpers = _a.helpers, pubsub = _a.pubsub, onConfirm = _a.onConfirm;
            if (validateUrl(url)) {
                if (onConfirm) {
                    onConfirm(__assign(__assign({}, componentData), { src: url }));
                }
                updateUrl(url, pubsub, helpers);
                _this.onCloseRequested();
            }
            else {
                _this.setState({ isValid: false });
            }
        };
        _this.removeLink = function () {
            var _a = _this.props, updateUrl = _a.componentData.updateUrl, helpers = _a.helpers, pubsub = _a.pubsub;
            _this.setState({
                url: '',
                isValid: true,
            });
            updateUrl('', pubsub, helpers);
            _this.onCloseRequested();
        };
        _this.onCloseRequested = function () {
            _this.props.helpers.closeModal();
        };
        _this.handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                setTimeout(function () { return _this.onConfirm(); });
            }
        };
        _this.styles = mergeStyles({ styles: styles, theme: props.theme });
        var _a = _this.props, getUrl = _a.componentData.getUrl, pubsub = _a.pubsub;
        _this.state = {
            url: props.componentData.inputAlwaysEmpty ? '' : getUrl(pubsub),
            isValid: true,
        };
        return _this;
    }
    SetLinkModal.prototype.render = function () {
        var _a = this.state, url = _a.url, isValid = _a.isValid;
        var _b = this.props.componentData, title = _b.title, description = _b.description, placeholder = _b.placeholder, showRemoveLink = _b.showRemoveLink, errorMessage = _b.errorMessage;
        return (React.createElement("div", { className: this.styles.container, onKeyDown: this.handleKeyDown },
            React.createElement("button", { className: this.styles['close-button'], onClick: this.onCloseRequested }),
            React.createElement("div", { className: this.styles.content },
                React.createElement("div", { className: this.styles.heading }, title),
                React.createElement(Input, { key: "urlInput", type: "text", label: description, hasError: !isValid && !!url, value: url || '', tabIndex: 1, onChange: this.onChange, className: styles['input-wrapper'], inputClassName: styles.input, placeholder: placeholder, errorMessage: !isValid && !!url ? errorMessage : '', autoFocus: true })),
            React.createElement("div", { className: styles.footer },
                showRemoveLink && (React.createElement("button", { className: classnames(styles.removeButton, url && styles.removeButton_active), onClick: this.removeLink }, "Remove link")),
                React.createElement("button", { className: styles.confirmButton, onClick: this.onConfirm }, "Submit"))));
    };
    SetLinkModal.propTypes = {
        onConfirm: PropTypes.func,
        pubsub: PropTypes.object,
        helpers: PropTypes.object.isRequired,
        componentData: PropTypes.object.isRequired,
        url: PropTypes.string,
        theme: PropTypes.object.isRequired,
        t: PropTypes.func,
    };
    SetLinkModal.defaultProps = {
        onChange: function () {
            // noop
        },
    };
    return SetLinkModal;
}(React.Component));
export default SetLinkModal;
//# sourceMappingURL=SetLinkModal.js.map